module.exports = __webpack_public_path__ + "img/icon_email_verify_success.ec28f8a3.png";